<div class="day-trade__container box">
  <div class="day-trade__header">
    <div class="widget-title">DAY TRADES</div>
    <img
      alt="Información"
      class="day-trade__header--info"
      src="images/atm-icn-help-info.svg"
      (click)="handleOpenDayTradeInfo()"
    />
  </div>

  <div class="day-trade__counter">0{{ dayTradesCount }} / 03</div>
  <div class="day-trade__description">
    Si deseas operar sin restricciones, el valor de tu portafolio debe ser mayor
    a $600,000
  </div>
  <div class="day-trade__detail">
    <div class="day-trade__item" *ngFor="let item of items; let i = index">
      <div
        class="day-trade__circle"
        [ngClass]="{
          'day-trade__circle--empty': !item.ticker || item.isVirtual
        }"
      >
        <div
          class="day-trade__item--number"
          [ngClass]="{
            'day-trade__item--virtual': item.isVirtual
          }"
          *ngIf="item.ticker"
        >
          0{{ i + 1 }}
        </div>
      </div>

      <div
        class="day-trade__item--ticker"
        [ngClass]="{
          'day-trade__item--virtual': item.isVirtual
        }"
      >
        {{ item.ticker }}
      </div>
    </div>
  </div>
  <div class="day-trade__next-date" *ngIf="dayTradesCount === 3">
    Podrás realizar otro a partir del {{ nextDateLabel }}
  </div>
</div>

<app-side-modal
  #sideModal
  (goBack)="handleCloseDayTradeInfo()"
  class="day-trade--details"
>
  <hb-day-trades-info></hb-day-trades-info>
</app-side-modal>
